import LogoHeader from '@stone/ui/logo/LogoHeader';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TickerBar from './TickerBar';
import TickerBOB from './TickerBOB';
import A11YMenuBar from '../a11y/A11YMenuBar';
import MenuDesktopDialog from './MenuDesktopDialog';
import SearchBtn from '@stone/components/search/SearchBtn';
import AccountMenu from '@stone/components/menu/AccountMenu';
import customEventBus from '@common/scripts/libs/eventBus';
const MenuDesktop = (props) => {
    // * CUSTOM HOOKS ------------------------------------------------------------------------------------------------
    const { t } = useTranslation();
    const sectionClasses = 'col-lg-8 col-xxl-6 menu-item';
    const numProduct = String(props.definitiveTotal || 0).padStart(2, '0');
    // * STATES  ------------------------------------------------------------------------------------------------
    const [fillingSections, setFillingSections] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);
    const [activeSection, setActiveSection] = useState(null);
    const [lastFocus, setLastFocus] = useState(null);
    // * USE EFFECT  ------------------------------------------------------------------------------------------------
    useEffect(() => {
        if (props.sections) {
            let fillingArray = [];
            let fillingValue = 3 - props.sections.length;
            for (let i = 0; i < fillingValue; i++) {
                fillingArray.push({});
            }
            setFillingSections(fillingArray);
        }
    }, [props.sections]);
    useEffect(() => {
        document.addEventListener('keydown', onKeyDown, false);
        return () => document.removeEventListener('keydown', onKeyDown, false);
    }, []);
    // * FUNCTIONS  ------------------------------------------------------------------------------------------------
    function deactivateMenu() {
        setActiveSection(null);
        setActiveIndex(null);
    }
    function changeFocus() {
        setTimeout(() => {
            const menuHeadingTOFocus = document.querySelector(lastFocus);
            menuHeadingTOFocus === null || menuHeadingTOFocus === void 0 ? void 0 : menuHeadingTOFocus.focus();
        }, 100);
    }
    function setActiveMenu(index) {
        const activeSection = props.sections[index];
        const lastFocus = `#menu-heading-${activeSection === null || activeSection === void 0 ? void 0 : activeSection.id}`;
        setLastFocus(lastFocus);
        setActiveSection(activeSection);
        setActiveIndex(index);
    }
    function onKeyDown(e) {
        if (e.key === 'Escape') {
            deactivateMenu();
        }
    }
    const isOpen = useMemo(() => {
        return !!activeSection;
    }, [activeSection]);
    // * COMPONENTS  ------------------------------------------------------------------------------------------------
    const MenuSection = (section) => {
        return (React.createElement("li", { "data-index": section.index, className: sectionClasses },
            React.createElement("button", { id: `menu-heading-${section.id}`, className: "menu-heading", 
                // data-analytics={`{"event": "menu", "eventCategory": "nav menu", "eventAction": "${section.data.title_analytics || section.data.title.toLowerCase()}"}`}
                onMouseEnter: () => setActiveMenu(section.index), onClick: () => setActiveMenu(section.index), "aria-expanded": activeIndex === section.index, "aria-haspopup": "dialog" }, section.data.title),
            props.isSSR && (React.createElement("div", { className: "menu-modal--overlay visually-hidden" },
                React.createElement(MenuDesktopDialog, { isSSR: true, changeFocus: changeFocus, deactivateMenu: deactivateMenu, isOpen: true, section: section, index: section.index, whatIntent: props.whatIntent })))));
    };
    const MenuSections = () => {
        return (React.createElement("nav", { id: "mainnav" },
            React.createElement("ul", { className: "row" },
                props.sections && props.sections.length && props.sections.map((section, i) => React.createElement(MenuSection, Object.assign({ key: `menu-section-${i}` }, section, { index: i }))),
                React.createElement(MenuFillingSections, null))));
    };
    const MenuFillingSections = () => {
        return React.createElement(React.Fragment, null, !!fillingSections.length && fillingSections.map((section, i) => React.createElement("li", { key: `filling-menu-section-${i}`, className: sectionClasses })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "header-topbar", "data-transparent": props.transparent, "data-color": props.color, "data-open": isOpen },
            props.clickFromStoreUrl && React.createElement(TickerBOB, { clickFromStoreUrl: props.clickFromStoreUrl }),
            React.createElement(TickerBar, { tickerSlides: props.tickerSlides }),
            React.createElement(A11YMenuBar, null),
            React.createElement("div", { className: "header-topbar__container", onMouseLeave: (e) => {
                    var _a;
                    const el = e.relatedTarget;
                    const menuModal = document.querySelector('.menu-modal__container');
                    if ((!(menuModal === null || menuModal === void 0 ? void 0 : menuModal.contains(el)) && !((_a = el.classList) === null || _a === void 0 ? void 0 : _a.contains('menu-modal__container'))) || e.relatedTarget === window) {
                        deactivateMenu();
                    }
                } },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-lg-9 col-xxl-8 header-area header-area__nav" },
                            React.createElement(MenuSections, null)),
                        React.createElement("div", { className: "col-lg-6  col-xxl-8 text-center" },
                            React.createElement("div", { className: "content" },
                                React.createElement(LogoHeader, null))),
                        activeIndex == null && !activeSection && (React.createElement("div", { className: "col-lg-5 offset-lg-4 offset-xxl-3 header-area header-area__actions" },
                            React.createElement(SearchBtn, { handleOpen: () => {
                                    deactivateMenu();
                                    props.setIsSearchOpen();
                                } }),
                            React.createElement(AccountMenu, { profileName: props.profileName, handleModalOpen: props.setIsLoginOpen, deactivateMenu: deactivateMenu }),
                            !window.unshoppable && (React.createElement("button", { className: "menu-heading menu-minicart-button", onClick: (e) => {
                                    deactivateMenu();
                                    customEventBus.emit('minicart:askforopen', { from: 'menu', originalEvent: e });
                                }, "aria-haspopup": "dialog" },
                                t('label.bag') + ' ' + numProduct,
                                React.createElement("span", { className: "visually-hidden" }, `${t(props.definitiveTotal === 1 ? 'label.item' : 'label.items')}`))))))))),
        !(props === null || props === void 0 ? void 0 : props.isSSR) && (React.createElement(MenuDesktopDialog, { changeFocus: changeFocus, deactivateMenu: deactivateMenu, isOpen: isOpen, section: isOpen && activeSection, index: isOpen && activeIndex, whatIntent: props.whatIntent }))));
};
export default MenuDesktop;
